import React            from "react";
import PropTypes        from "prop-types";
import Flux             from "../../flux/Flux";
import VideoTile        from "../Grid2/Tiles/VideoTile";
import Grid2            from "../Grid2/Grid2";
import withVideos       from "../HigherOrderComponents/Videos/withVideos";
import withWindowWidth  from "../HigherOrderComponents/Utility/withWindowWidth";
import withStaticLoader from "../HigherOrderComponents/Utility/withStaticLoader";
import Grid2Helper      from "../../utils/Grid2Helper";

class VIP30Grid extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			videos:       null,
		};

		this.addVideoLike    = this.addVideoLike.bind(this);
		this.addVideoDislike = this.addVideoDislike.bind(this);
		this.changeVideoLike = this.changeVideoLike.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addVideoLikeChangeListener(this.addVideoLike);
		Flux.Guest.addVideoDislikeChangeListener(this.addVideoDislike);
		if (this.props.videos) {
			this.setVideos(this.props.videos);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.videos.length > 0 && (this.props.videos !== this.state.videos)) {
			this.setVideos(this.props.videos);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.videos.length > 0 && (nextProps.videos !== this.state.videos)) || this.state.videos !== nextState.videos;
	}

	componentWillUnmount() {
		Flux.Guest.removeVideoLikeChangeListener(this.addVideoLike);
		Flux.Guest.removeVideoDislikeChangeListener(this.addVideoDislike);
	}

	setVideos(videos) {
		videos.sort((a, b) => (a.rating.likes < b.rating.likes) ? 1 : -1);
		this.setState({videos});
	}

	addVideoLike(videoId) {
		this.changeVideoLike(true, videoId);
	}

	addVideoDislike(videoId) {
		this.changeVideoLike(false, videoId);
	}

	changeVideoLike(liked, videoId) {
		const videos = [...this.state.videos].map(item => {
			if (item.id === videoId) {
				item.rating.likes = liked ? item.rating.likes + 1 : item.rating.likes - 1;
			}

			return item;
		});
		this.setState({videos});
	}

	render() {
		if (!this.state.videos) {
			return null;
		}

		let videos     = this.state.videos;
		let columns    = {xs: 2, sm: 3, md: 4, lg: 4};
		let tileConfig = {badges: {textBadges: {show: {price: Flux.Guest.isLoggedIn(), new: false}}}};
		let slider     = this.props.isMobile;

		if (!this.props.isMobile && !this.props.isVIP30Site) {
			const videoLength = Grid2Helper.getItemCountForFullRows(columns, Grid2Helper.getBreakpointByWindowWidth(this.props.windowWidth), videos.length);

			if (videoLength) {
				videos = videos.splice(0, videoLength);
			}
		}

		if (this.props.isVIP30Site) {
			columns    = {xs: 2, sm: 3, md: 3, lg: 3};
			tileConfig = {footer: {growActorname: true, show: {likeBtn: true}}, badges: {textBadges: {show: {fsk18: false, price: false, new: false, rating: true}}}};
			slider     = false;
		}



		return (
			<Grid2 tileData={videos}
			       defaultTileClass={VideoTile}
			       columns={columns}
			       defaultTileConfig={tileConfig}
			       slider={slider}
			       tilePadding={Flux.Constants.Grid2.TilePadding.SMALL}
				   lazyImageLoading={this.props.lazyImageLoading}
				   headlineType={this.props.headlineType}
			/>
		);
	}
}

VIP30Grid.propTypes = {
	videos:           PropTypes.array,
	loading:          PropTypes.bool.isRequired,
	windowWidth:      PropTypes.number.isRequired,
	isMobile:         PropTypes.bool,
	isVIP30Site:      PropTypes.bool,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
};

VIP30Grid.defaultProps = {
	isMobile:         false,
	isVIP30Site:      false,
	lazyImageLoading: false,
};


export default withWindowWidth(withVideos(withStaticLoader(VIP30Grid)));
